import {useState, useEffect} from 'react';
import Cookies from 'utils/cookies';
import {COOKIE_CONSENT_VERSION} from 'configs';

function useCookieConsent() {
  const {version, ...cookieConsent} = Cookies.consent || {};

  const outdatedVersion = version !== COOKIE_CONSENT_VERSION;

  const [consents, setConsents] = useState(
    outdatedVersion ? {} : cookieConsent
  );
  const [showBanner, setShowBanner] = useState(outdatedVersion);
  const [isBannerVisible, setIsBannerVisible] = useState(outdatedVersion);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window.setConsent === 'function') {
      window.setConsent(consents);
    }
  }, [consents]);

  function toggleOpen() {
    setIsOpen(!isOpen);
  }

  function onAcceptCookies(consent) {
    window?.dataLayer?.push({
      cookieConsentNecessary: consent.necessary,
      cookieConsentStatistics: consent.analytics,
      cookieConsentMarketing: consent.marketing,
      event: 'accept cookie consent modal',
    });

    const payload = {...consent, version: COOKIE_CONSENT_VERSION};

    Cookies.consent = payload;
    setConsents(payload);

    setIsOpen(false);
    setShowBanner(false);
    // transition on css is set to 0.5s
    setTimeout(() => setIsBannerVisible(false), 500);
  }

  return {
    isOpen,
    showBanner,
    isBannerVisible,
    toggleOpen,
    onAcceptCookies,
    consents,
    setConsents,
  };
}

export default useCookieConsent;
